
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/guidelines",
      function () {
        return require("private-next-pages/[lang]/guidelines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/guidelines"])
      });
    }
  